
























import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { Search } from '~/models/search/types'
import { ciBookmark } from '~/icons/source/regular/bookmark'
import { ciBookmark as ciBookmarkSolid } from '~/icons/source/solid/bookmark'

export default defineComponent({
  props: {
    search: {
      type: Object as PropType<Search>,
      required: true
    }
  },
  emits: ['add-favorite', 'remove-favorite'],
  setup(props, { emit }) {
    const handleFavoriteChange = (isFavorite?: boolean) => {
      const { id } = props.search
      if (isFavorite) {
        emit('remove-favorite', id)
      } else {
        emit('add-favorite', id)
      }
    }
    return { ciBookmark, ciBookmarkSolid, handleFavoriteChange }
  }
})
